module.exports = __webpack_public_path__ + "img/donante-blindajes-epel.ac6bc25a.jpg";